class MHeader extends HTMLElement {
  constructor() {
    super()

    this.selectors = {
      headers: ['header'],
      logos: ['.m-logo'],
      topbar: '.m-topbar',
      headerWrapper: '.m-header__wrapper',
      topbarClose: '.m-topbar__close',
      stickySearch: '[data-sticky-search]',
    }
    this.domNodes = queryDomNodes(this.selectors, this)
    this.innerWidth = window.innerWidth
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight
    this.stickyHeader = this.dataset.sticky
    this.lastScrollTop = window.scrollY
    this.scrollThreshold = 20
    this.classes = {
      scrollUp: 'scroll-up',
      scrollDown: 'scroll-down',
      stuck: 'stuck',
      always: 'header-sticky-always',
      searchOnly: 'search-only',
      headerScrollUp: 'header-scroll-up',
      headerScrollDown: 'header-scroll-down',
    }

    this.handleScroll = this.handleScroll.bind(this)
    this.updateStickyMetrics = this.updateStickyMetrics.bind(this)
    this.init()
  }

  init() {
    this.transparentHeader =
      this.domNodes &&
      this.domNodes.headers[0] &&
      this.domNodes.headers[0].dataset.transparent === 'true'

    this.initAddon()
    this.updateStickyMetrics()
    this.handleScroll()

    window.addEventListener('scroll', this.handleScroll, { passive: true })
    document.addEventListener('matchMobile', this.updateStickyMetrics)
    document.addEventListener('unmatchMobile', this.updateStickyMetrics)

    this.siteNav = new SiteNav(this)
    window.__sfHeader = this
    window.addEventListener('resize', () => {
      this.innerWidth = window.innerWidth
      this.updateStickyMetrics()
    })
  }

  initAddon() {
    this.megamenu = new Megamenu(this)
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {}
      if (MinimogTheme && MinimogTheme.Wishlist) {
        MinimogTheme.Wishlist.updateWishlistCount()
      }
    }
  }

  updateStickyMetrics() {
    let threshold = 20

    document.querySelectorAll('.shopify-section-group-header-group').forEach((section) => {
      if (!section.classList.contains('m-section-header') && !section.classList.contains('m-section-scaling-logo')) {
        threshold += section.offsetHeight
      }
    })

    const topbar = document.querySelector('.m-topbar')
    if (topbar) threshold += topbar.offsetHeight

    this.scrollThreshold = threshold
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight
  }

  resetStickyState() {
    this.classList.remove(
      this.classes.scrollUp,
      this.classes.scrollDown,
      this.classes.stuck,
      this.classes.always
    )
    document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown)
    this.setSearchOnlyState(false)
  }

  setSearchOnlyState(active) {
    const searchBar = this.domNodes.stickySearch
    this.classList.toggle(this.classes.searchOnly, active)
    if (searchBar) searchBar.setAttribute('aria-hidden', active ? 'false' : 'true')
  }

  handleScroll() {
    const scrollTop = window.scrollY

    if (scrollTop <= this.scrollThreshold) {
      this.resetStickyState()
      this.lastScrollTop = scrollTop
      return
    }

    if (this.stickyHeader === 'on_scroll_up' || this.stickyHeader === 'hide_keep_search') {
      this.classList.add(this.classes.stuck)
      this.classList.remove(this.classes.always)
    } else if (this.stickyHeader === 'always') {
      this.classList.add(this.classes.always)
      this.classList.remove(this.classes.stuck)
    } else {
      this.classList.remove(this.classes.stuck, this.classes.always)
    }

    const directionThreshold = this.headerHeight + this.scrollThreshold
    const scrollingDown = scrollTop > this.lastScrollTop

    if (scrollTop > directionThreshold) {
      if (scrollingDown && !this.classList.contains(this.classes.scrollDown)) {
        this.classList.remove(this.classes.scrollUp)
        document.body.classList.remove(this.classes.headerScrollUp)
        this.classList.add(this.classes.scrollDown)
        document.body.classList.add(this.classes.headerScrollDown)
        this.setSearchOnlyState(this.stickyHeader === 'hide_keep_search')
      } else if (!scrollingDown && this.classList.contains(this.classes.scrollDown)) {
        this.classList.remove(this.classes.scrollDown)
        document.body.classList.remove(this.classes.headerScrollDown)
        this.classList.add(this.classes.scrollUp)
        document.body.classList.add(this.classes.headerScrollUp)
        this.setSearchOnlyState(false)
      }
    } else if (this.stickyHeader === 'hide_keep_search') {
      this.classList.remove(this.classes.scrollDown)
      document.body.classList.remove(this.classes.headerScrollDown)
      this.setSearchOnlyState(false)
    }

    this.lastScrollTop = scrollTop
  }
}

customElements.define('m-header', MHeader)
